import React from 'react';
import { Drawer, type DrawerProps } from '@mui/material';
import { type BaseCSSProperties } from '@mui/material/styles/createMixins';
import { cs } from '@bbkAdminUtils/css-utils';

type Props = DrawerProps & {
  // add more styles that you want to support
  // trying to limit
  drawerStyles?: Pick<
    BaseCSSProperties,
    'overflow' | 'position' | 'height' | 'width' | 'backgroundColor'
  >;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  disablePortal?: boolean;
  hideBackdrop?: boolean;
  disableEnforceFocus?: boolean;
};

export const EditorDrawer: React.FC<Props> = ({
  open,
  onClose,
  drawerStyles = {},
  anchor,
  disablePortal = false,
  hideBackdrop = false,
  disableEnforceFocus = false,
  ...restProps
}) => {
  const resolvedAnchor = anchor ?? 'bottom';
  return (
    <Drawer
      open={open}
      anchor={resolvedAnchor}
      className={cs({
        'tw-absolute tw-h-full tw-w-full': disablePortal,
      })}
      PaperProps={{
        className: cs('!tw-h-screen tw-bg-[#F6F8FB]', {
          '!tw-w-screen': resolvedAnchor === 'bottom',
          '!tw-absolute !tw-h-full': disablePortal,
        }),
        style: drawerStyles,
      }}
      ModalProps={{
        ...(disablePortal && {
          disablePortal: true,
        }),
        ...(hideBackdrop && {
          hideBackdrop: true,
        }),
        // Opt-in: disable MUI's focus trap only where it conflicts with sting-react
        // components (focus loops between nested modals causing maximum recursion).
        // Keep focus containment enabled by default for accessibility.
        ...(disableEnforceFocus && {
          disableEnforceFocus: true,
        }),
      }}
      onClose={onClose}
      {...restProps}
    />
  );
};
